module.exports = __webpack_public_path__ + "static/media/passwordanimation.9ffd7716.gif";